import { IconNames } from "@smartsuite/icons";
import { Fields } from "@smartsuite/types";

export const fieldTypeIcons: Partial<Record<Fields, IconNames>> = {
  addressfield: "address",
  autonumberfield: "auto-number",
  buttonfield: "button",
  checklistfield: "checklist",
  colorpickerfield: "drop",
  commentscountfield: "comment-2",
  countfield: "count",
  currencyfield: "currency",
  datefield: "date-select",
  daterangefield: "date-range",
  duedatefield: "due-date",
  durationfield: "duration",
  emailfield: "email",
  filefield: "attachment",
  firstcreatedfield: "due-date",
  formulafield: "formula",
  fullnamefield: "full-name",
  ipaddressfield: "ip",
  lastupdatedfield: "due-date",
  linkedrecordfield: "linked-record",
  linkfield: "link",
  lookupfield: "lookup",
  multipleselectfield: "multiple-select",
  numberfield: "number",
  numbersliderfield: "number-slider",
  percentcompletefield: "progress",
  percentfield: "percent",
  phonefield: "phone",
  ratingfield: "rating-field",
  recordidfield: "record-id",
  recordtitlefield: "record-title",
  rollupfield: "rollup",
  signaturefield: "signature",
  singleselectfield: "single-select",
  richtextareafield: "smartdoc",
  socialnetworkfield: "social-network",
  statusfield: "status",
  subitems2field: "journal",
  tagsfield: "tag",
  textareafield: "textarea",
  textfield: "text",
  timefield: "clock",
  timetrackingfield: "time-tracking",
  userfield: "user",
  votefield: "vote",
  yesnofield: "yes-and-no",
  availabilitystatusfield: "",
  textnestedfield: "",
  unknownfield: "",
};

export const disabledFieldTypes: Fields[] = [
  "buttonfield",
  "checklistfield",
  "colorpickerfield",
  "subitemsfield",
  "commentscountfield",
];
